var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('head',[_c('meta',{attrs:{"http-equiv":"refresh","content":"0; url='https://www.google.com'"}})]),_c('body',[_c('p',[_vm._v("Hmmm...")])])])
}]

export { render, staticRenderFns }